module.exports = __webpack_public_path__ + "static/media/forkLeft.3645d2c2.png";